
        <div class="date">
            <span class="weekday">{{getWeekday()}}</span>
            <br>
            <span class="day">{{getDate()}}</span>
            <br>
            <span class="year">{{getYear()}}</span>
        </div>
    